import React from 'react';
import Element, { CommonProps } from '../Element/Element';
import styles from './LinkList.module.scss';
import LinkListHeading from './LinkListHeading/LinkListHeading';
import LinkListItem from './LinkListItem/LinkListItem';

type LinkListProps = CommonProps<'ul'>;

const LinkList: React.FunctionComponent<LinkListProps> & {
  Item: typeof LinkListItem;
  Heading: typeof LinkListHeading;
} = ({ children, ...props }) => {
  return (
    <Element tagName="ul" className={styles.linkList} {...props}>
      {children}
    </Element>
  );
};

LinkList.Heading = LinkListHeading;
LinkList.Item = LinkListItem;

export default LinkList;
